module.exports = __webpack_public_path__ + "static/media/bn-BD.6b6e6547.md";